import { ComponentRef, Injectable } from '@angular/core';
import { IProductAvailabilityNotificationConfirmationDialogService } from 'projects/shared/lib/interfaces/services/dialogs/product-availability-notification-confirmation-dialog-service.abstract';
import { DialogBaseService } from 'projects/shared/lib/services/ui/dialog.service';
import { ProductAvailabilityNotificationConfirmationDialogComponent } from '../../components/shared/product/availability/product-availability-notification-confirmation-dialog/product-availability-notification-confirmation-dialog.component';

@Injectable({
  providedIn: 'root'
})
export class ProductAvailabilityNotificationConfirmationDialogService implements IProductAvailabilityNotificationConfirmationDialogService {

  productAvailabilityNotificationConfirmationDialogShow(
    callbackCancel: () => void,
    callbackYes?: (() => void) | undefined,
    callbackNo?: (() => void) | undefined): void {

    DialogBaseService.dialogGenericShow(
      ProductAvailabilityNotificationConfirmationDialogComponent,
      (componentRef: ComponentRef<ProductAvailabilityNotificationConfirmationDialogComponent>) => {
        let component = componentRef.instance;

        component.modalCancel.subscribe(
          () => {
            callbackCancel();
            DialogBaseService.dynamicComponentRemove(componentRef);
          }
        );

        component.modalYes.subscribe(
          () => {
            callbackYes?.();
            DialogBaseService.dynamicComponentRemove(componentRef);
          }
        );

        component.modalNo.subscribe(
          () => {
            callbackNo?.();
            DialogBaseService.dynamicComponentRemove(componentRef);
          }
        );

      }
    );
  }

}
